/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ConditionsInner } from './ConditionsInner';
import {
    ConditionsInnerFromJSON,
    ConditionsInnerFromJSONTyped,
    ConditionsInnerToJSON,
} from './ConditionsInner';

/**
 * 
 * @export
 * @interface ControlAndCondition
 */
export interface ControlAndCondition {
    /**
     * 
     * @type {string}
     * @memberof ControlAndCondition
     */
    type?: string;
    /**
     * 
     * @type {Array<ConditionsInner>}
     * @memberof ControlAndCondition
     */
    conditions: Array<ConditionsInner>;
}

/**
 * Check if a given object implements the ControlAndCondition interface.
 */
export function instanceOfControlAndCondition(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "conditions" in value;

    return isInstance;
}

export function ControlAndConditionFromJSON(json: any): ControlAndCondition {
    return ControlAndConditionFromJSONTyped(json, false);
}

export function ControlAndConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAndCondition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'conditions': ((json['conditions'] as Array<any>).map(ConditionsInnerFromJSON)),
    };
}

export function ControlAndConditionToJSON(value?: ControlAndCondition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'conditions': ((value.conditions as Array<any>).map(ConditionsInnerToJSON)),
    };
}

